/* eslint-disable import/prefer-default-export */

import axiosIns from '@/plugins/axios'
import {
  mdiAccount,
  mdiAccountCheck,
  mdiAccountCog,
  mdiAccountGroupOutline,
  mdiAccountKey,
  mdiApps,
  mdiDomain,
  mdiEarthPlus,
  mdiFileTableBoxMultiple,
  mdiHomeOutline,
} from '@mdi/js'

const iconMap = {
  Dashboard: mdiHomeOutline,
  Sistemas: mdiApps,
  Grupos: mdiAccountGroupOutline,
  Regiões: mdiEarthPlus,
  Empresas: mdiDomain,
  Perfis: mdiAccountCheck,
  Usuários: mdiAccount,
  'Sistemas de acesso': mdiAccountKey,
  'Ocupação / Função': mdiAccountCog,
  Setores: mdiFileTableBoxMultiple,
  URLs: mdiApps,
}

export async function getDynamicRoutes() {
  try {
    const response = await axiosIns.get('api/v1/records/user/logged_in_user')
    const userProfile = response.data.data

    const systems = userProfile.access_systems_new?.data || []
    const admNexusSystem = systems.find(system => system.system === 'AdmNexus')

    let dynamicRoutes = []

    if (admNexusSystem && Array.isArray(admNexusSystem.menu)) {
      dynamicRoutes = admNexusSystem.menu.map(menuItem => ({
        title: menuItem.name,
        to: menuItem.navigate,
        icon: iconMap[menuItem.name] || mdiApps,
      }))
    }

    return [
      {
        subheader: 'Ferramentas do Administrador',
      },
      ...dynamicRoutes,
    ]
  } catch (error) {
    console.error('Erro ao buscar sistemas:', error)

    return []
  }
}
